import {
	MimaButton,
	MimaText,
	PageLoader,
	MimaInput,
	MimaTextArea,
	ReceiptCheckBox as RCB,
} from '../../components';
import styles from '../../assets/styles/PaymentLink/PaymentLinkCheckout.module.scss';
import { paymentLinkStore } from '../../stores';
import { amountFormatter } from '../../utils/utils';
import { Formik } from 'formik';
import Logo from '../../assets/img/mima-logo.png';
import React from 'react';
import constant from '../../utils/constant';

const PaymentLinkCheckout = ({
	paymentCheckoutDetails,
	validationSchema,
	onSubmit,
	loading,
	getExactCharge,
	charges,
	showCharge,
	setshowCharge,
	paystackCharge,
}) => {
	const business = paymentCheckoutDetails.business;

	return (
		<div className={styles.main}>
			{loading ? (
				<PageLoader title="while we load link info" variant="light" />
			) : (
				<>
					{business?.logoUrl ? (
						<img
							src={business.logoUrl}
							className={styles.main__img}
							alt="logo"
						/>
					) : (
						''
					)}
					<div className={styles.main__titles}>
						<MimaText
							variant="subtitleBold"
							mt={1}
							align="center"
							color="var(--color-white)">
							{paymentCheckoutDetails.title}
						</MimaText>
						<MimaText
							variant="bodyBold"
							align="center"
							color="var(--color-white)">
							by {business.tradingName}
						</MimaText>
						<MimaText
							variant="body"
							align="center"
							mb={2}
							color="var(--color-white)">
							{paymentCheckoutDetails.description}
						</MimaText>
					</div>

					<Formik
						initialValues={{
							amount:
								!paymentCheckoutDetails.acceptPartPayment &&
								paymentCheckoutDetails.amount > 0
									? paymentCheckoutDetails.amount
									: '',
							fullname: '',
							email: '',
							mobile: '',
							quantity: 1,
							address: '',
							acceptQuantity: paymentCheckoutDetails.acceptQuantity,
							acceptPhoneNumber: paymentCheckoutDetails.acceptPhoneNumber,
							acceptInstagramHandle:
								paymentCheckoutDetails.acceptInstagramHandle,
							acceptAddress: paymentCheckoutDetails.acceptAddress,
							payWith: 'TRANSFER',
							minDeposit: paymentCheckoutDetails.minDeposit,
							terms: false,
							refundPolicy: false,
						}}
						validationSchema={validationSchema}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => {
							return (
								<div className={styles.main__form}>
									<MimaText variant="subtitleBold" align="center">
										{paymentCheckoutDetails.currencyCode}
									</MimaText>

									{!paymentCheckoutDetails.acceptPartPayment &&
									paymentCheckoutDetails.amount > 0 ? (
										<MimaText
											variant="h3"
											mb={1}
											mt={2}
											labelTitle={
												paymentCheckoutDetails.acceptQuantity
													? 'Amount per Quantity'
													: 'Amount to pay'
											}>
											{amountFormatter(
												paymentCheckoutDetails.currencyCode
											).format(paymentCheckoutDetails.amount)}
										</MimaText>
									) : (
										<MimaInput
											labelTitle="Enter payment Amount"
											variant="form2"
											type="number"
											placeholder="0.00"
											name="amount"
											id="amount"
											value={values.amount}
											onChange={handleChange}
											onBlur={e => {
												handleBlur(e);
												setshowCharge(false);
												paymentLinkStore.setCharges();
												if (!paymentCheckoutDetails.acceptQuantity) {
													getExactCharge(values);
												}
											}}
											touched={touched.amount}
											error={errors.amount}
										/>
									)}

									{paymentCheckoutDetails.acceptQuantity ? (
										<MimaInput
											labelTitle="Quantity"
											variant="form2"
											type="number"
											placeholder="1"
											name="quantity"
											id="quantity"
											value={values.quantity}
											onChange={handleChange}
											onBlur={e => {
												handleBlur(e);
												setshowCharge(false);
												paymentLinkStore.setCharges();
												getExactCharge(values);
											}}
											touched={touched.quantity}
											error={errors.quantity}
										/>
									) : (
										''
									)}

									<div className={styles.beside}>
										{paymentCheckoutDetails.amount !== 0 &&
										paymentCheckoutDetails.acceptQuantity ? (
											<MimaText
												variant="bodyBold"
												color="var(--color-primary)"
												mb={1}
												labelTitle="Amount Due">
												{amountFormatter(
													paymentCheckoutDetails.currencyCode
												).format(values.amount * values.quantity)}
											</MimaText>
										) : paymentCheckoutDetails.amount !== 0 ? (
											<MimaText
												variant="bodyBold"
												color="var(--color-primary)"
												mb={1}
												labelTitle="Amount Due">
												{amountFormatter(
													paymentCheckoutDetails.currencyCode
												).format(paymentCheckoutDetails.amount)}
											</MimaText>
										) : (
											' '
										)}

										{paymentCheckoutDetails.minDeposit !== 0 &&
										paymentCheckoutDetails.acceptQuantity ? (
											<MimaText
												variant="bodyBold"
												color="var(--color-error)"
												mb={1}
												labelTitle="Minimum Deposit">
												{amountFormatter(
													paymentCheckoutDetails.currencyCode
												).format(
													paymentCheckoutDetails.minDeposit * values.quantity
												)}
											</MimaText>
										) : paymentCheckoutDetails.minDeposit !== 0 ? (
											<MimaText
												variant="bodyBold"
												color="var(--color-error)"
												mb={1}
												labelTitle="Minimum Deposit">
												{amountFormatter(
													paymentCheckoutDetails.currencyCode
												).format(paymentCheckoutDetails.minDeposit)}
											</MimaText>
										) : (
											' '
										)}
									</div>

									<MimaInput
										labelTitle="Full Name"
										variant="form2"
										placeholder="Full Name"
										name="fullname"
										id="fullname"
										value={values.fullname}
										onChange={handleChange}
										onBlur={e => {
											handleBlur(e);
											setshowCharge(false);
											paymentLinkStore.setCharges();
											getExactCharge(values);
										}}
										touched={touched.fullname}
										error={errors.fullname}
									/>

									<MimaInput
										labelTitle="Your Email Address"
										type="email"
										variant="form2"
										placeholder="Your email address"
										name="email"
										id="email"
										value={values.email}
										onChange={handleChange}
										onBlur={handleBlur}
										touched={touched.email}
										error={errors.email}
									/>

									{paymentCheckoutDetails.acceptPhoneNumber ? (
										<MimaInput
											labelTitle="Your Phone Number"
											type="tel"
											variant="form2"
											placeholder="Your Phone Number"
											name="mobile"
											id="mobile"
											value={values.mobile}
											onChange={handleChange}
											onBlur={handleBlur}
											touched={touched.mobile}
											error={errors.mobile}
										/>
									) : (
										''
									)}

									{paymentCheckoutDetails.acceptInstagramHandle ? (
										<MimaInput
											labelTitle="Your Instagram Handle"
											variant="form2"
											placeholder="Your Instagram Handle"
											name="instagramHandle"
											id="instagramHandle"
											value={values.instagramHandle}
											onChange={handleChange}
											onBlur={handleBlur}
											touched={touched.instagramHandle}
											error={errors.instagramHandle}
										/>
									) : (
										''
									)}

									{paymentCheckoutDetails.acceptAddress ? (
										<MimaTextArea
											labelTitle="Address"
											textAreaVariant="type3"
											placeholder="Enter Address"
											name="address"
											id="address"
											value={values.address}
											onChange={handleChange}
											onBlur={handleBlur}
											touched={touched.address}
											error={errors.address}
										/>
									) : (
										''
									)}

									<div className={styles.beside}>
										{paymentCheckoutDetails.currencyCode === 'NGN' && (
											<RCB
												title="Pay with Transfer"
												onChange={() => {
													setFieldValue('payWith', 'TRANSFER');
												}}
												checked={values.payWith === 'TRANSFER'}
												value="TRANSFER"
												name="payWith"
											/>
										)}
										{/*Pay with card is temporarily disabled  */}
										{/* {paymentCheckoutDetails.currencyCode === 'NGN' && (
											<RCB
												title="Pay with Card"
												onChange={() => {
													setFieldValue('payWith', 'CARD');
												}}
												checked={values.payWith === 'CARD'}
												value="CARD"
												name="payWith"
											/>
										)} */}

										{showCharge && values.payWith === 'TRANSFER' ? (
											<>
												<MimaText
													variant="bodyBold"
													color="var(--color-primary-4)"
													mb={1}
													labelTitle="Payment Charge">
													{amountFormatter(
														paymentCheckoutDetails.currencyCode
													).format(charges?.chargeAmount)}
												</MimaText>

												<MimaText
													variant="bodyBold"
													color="var(--color-green)"
													mb={1}
													labelTitle="You will pay">
													{amountFormatter(
														paymentCheckoutDetails.currencyCode
													).format(
														values.amount * values.quantity +
															charges?.chargeAmount
													)}
												</MimaText>
											</>
										) : (
											''
										)}

										{values.payWith === 'CARD' ? (
											<>
												<MimaText
													variant="bodyBold"
													color="var(--color-primary-4)"
													mb={1}
													labelTitle="Payment Charge">
													{amountFormatter(
														paymentCheckoutDetails.currencyCode
													).format(paystackCharge)}
												</MimaText>

												<MimaText
													variant="bodyBold"
													color="var(--color-green)"
													mb={1}
													labelTitle="You will pay">
													{amountFormatter(
														paymentCheckoutDetails.currencyCode
													).format(
														values.amount * values.quantity + paystackCharge
													)}
												</MimaText>
											</>
										) : (
											''
										)}
									</div>

									{/* <div className={styles.linksContainer}>
										<a
											href={`${constant.Routes.TermsOfService}?businessName=${encodeURIComponent(business.tradingName)}`}
											target="_blank"
											rel="noopener noreferrer"
											className={styles.link}>
											Click to view Terms Of Service
										</a>
									</div> */}

									{/* <div>
										<MimaText variant="small">Accept Terms of Service</MimaText>
										<div className={styles.beside2}>
											<RCB
												title="Yes"
												onChange={() => {
													setFieldValue('terms', true);
												}}
												checked={values.terms}
												value="true"
												name="terms"
											/>
											<RCB
												title="No"
												checked={!values.terms}
												onChange={() => setFieldValue('terms', false)}
												value="false"
												name="terms"
												mb={1}
											/>
										</div>
									</div> */}
									<div className={styles.linksContainer}>
										<a
											href={`${constant.Routes.RefundPolicy}?businessName=${encodeURIComponent(business.tradingName)}&email=${encodeURIComponent(business.email)}`}
											target="_blank"
											rel="noopener noreferrer"
											className={styles.link}>
											Click to view our Refund Policy
										</a>
									</div>
									<div>
										<MimaText variant="small">Accept Refund Policy</MimaText>
										<div className={styles.beside2}>
											<RCB
												title="Yes"
												onChange={() => {
													setFieldValue('refundPolicy', true);
												}}
												checked={values.refundPolicy}
												value="true"
												name="refundPolicy"
											/>
											<RCB
												title="No"
												checked={!values.refundPolicy}
												onChange={() => setFieldValue('refundPolicy', false)}
												value="false"
												name="refundPolicy"
												mb={1}
											/>
										</div>
									</div>

									<MimaButton
										title="Make Payment"
										onClick={handleSubmit}
										variant="filterForm"
										mt={2}
										disabled={values.refundPolicy === false ? true : false}
									/>

									{/* <div className={styles.linksContainer}>
										<a
											href={`${constant.Routes.TermsOfService}?businessName=${encodeURIComponent(business.tradingName)}`}
											target="_blank"
											rel="noopener noreferrer"
											className={styles.link}>
											Terms Of Service
										</a>
										<a
											href={`${constant.Routes.RefundPolicy}?businessName=${encodeURIComponent(business.tradingName)}&email=${encodeURIComponent(business.email)}`}
											target="_blank"
											rel="noopener noreferrer"
											className={styles.link}>
											Refund Policy
										</a>
									</div> */}
									<div className={styles.mima}>
										<p>Powered by</p>{' '}
										<img
											src={Logo}
											className={styles.mima__logo}
											alt="Mima Logo"
										/>
									</div>
								</div>
							);
						}}
					</Formik>
				</>
			)}
		</div>
	);
};

export default PaymentLinkCheckout;
